import { createReducer } from 'reduxsauce'

import importer from 'common/importer'

const { INITIAL_STATE } = importer('Stores/Appointments/InitialState', null)
const { AppointmentsTypes } = importer('Stores/Appointments/Actions', null)

const scheduleAppointmentLoading = state => ({
  ...state,
  scheduleAppointmentLoading: true,
  scheduleAppointmentSuccess: null,
  scheduleAppointmentFailure: null
})
const scheduleAppointmentSuccess = (state, { res }) => ({
  ...state,
  appointments: res,
  scheduleAppointmentLoading: false,
  scheduleAppointmentSuccess: res,
  scheduleAppointmentFailure: null
})
const scheduleAppointmentFailure = (state, { error }) => ({
  ...state,
  scheduleAppointmentLoading: false,
  scheduleAppointmentSuccess: null,
  scheduleAppointmentFailure: error
})

const scheduleQuickAppointmentLoading = state => ({
  ...state,
  scheduleQuickAppointmentLoading: true,
  scheduleQuickAppointmentSuccess: null,
  scheduleQuickAppointmentFailure: null
})
const scheduleQuickAppointmentSuccess = (state, { res }) => ({
  ...state,
  appointments: res,
  scheduleQuickAppointmentLoading: false,
  scheduleQuickAppointmentSuccess: res,
  scheduleQuickAppointmentFailure: null
})
const scheduleQuickAppointmentFailure = (state, { error }) => ({
  ...state,
  scheduleQuickAppointmentLoading: false,
  scheduleQuickAppointmentSuccess: null,
  scheduleQuickAppointmentFailure: error
})

const getAllAppointmentsLoading = state => ({
  ...state,
  getAllAppointmentsLoading: true,
  getAllAppointmentsSuccess: null,
  getAllAppointmentsFailure: null
})
const getAllAppointmentsSuccess = (state, { res }) => ({
  ...state,
  getAllAppointmentsLoading: false,
  getAllAppointmentsSuccess: res,
  getAllAppointmentsFailure: null
})
const getAllAppointmentsFailure = (state, { error }) => ({
  ...state,
  getAllAppointmentsLoading: false,
  getAllAppointmentsSuccess: null,
  getAllAppointmentsFailure: error
})

const getAppointmentLoading = state => ({
  ...state,
  getAppointmentLoading: true,
  getAppointmentSuccess: null,
  getAppointmentFailure: null
})
const getAppointmentSuccess = (state, { res }) => ({
  ...state,
  getAppointmentLoading: false,
  getAppointmentSuccess: res,
  getAppointmentFailure: null
})
const getAppointmentFailure = (state, { error }) => ({
  ...state,
  getAppointmentLoading: false,
  getAppointmentSuccess: null,
  getAppointmentFailure: error
})

const rescheduleAppointmentLoading = state => ({
  ...state,
  rescheduleAppointmentLoading: true,
  rescheduleAppointmentSuccess: null,
  rescheduleAppointmentFailure: null
})
const rescheduleAppointmentSuccess = (state, { res }) => ({
  ...state,
  rescheduleAppointmentLoading: false,
  rescheduleAppointmentSuccess: res,
  rescheduleAppointmentFailure: null
})
const rescheduleAppointmentFailure = (state, { error }) => ({
  ...state,
  rescheduleAppointmentLoading: false,
  rescheduleAppointmentSuccess: null,
  rescheduleAppointmentFailure: error
})

const cancelAppointmentLoading = state => ({
  ...state,
  cancelAppointmentLoading: true,
  cancelAppointmentSuccess: null,
  cancelAppointmentFailure: null
})
const cancelAppointmentSuccess = (state, { res }) => ({
  ...state,
  cancelAppointmentLoading: false,
  cancelAppointmentSuccess: res,
  cancelAppointmentFailure: null
})
const cancelAppointmentFailure = (state, { error }) => ({
  ...state,
  cancelAppointmentLoading: false,
  cancelAppointmentSuccess: null,
  cancelAppointmentFailure: error
})

/* NEW */

const getAvailableSlotsLoading = state => ({
  ...state,
  getAvailableSlotsLoading: true,
  getAvailableSlotsSuccess: null,
  getAvailableSlotsFailure: null
})
const getAvailableSlotsSuccess = (state, { res }) => ({
  ...state,
  getAvailableSlotsLoading: false,
  getAvailableSlotsSuccess: res,
  getAvailableSlotsFailure: null
})
const getAvailableSlotsFailure = (state, { error }) => ({
  ...state,
  getAvailableSlotsLoading: false,
  getAvailableSlotsSuccess: null,
  getAvailableSlotsFailure: error
})
//
const getBookedSlotsLoading = state => ({
  ...state,
  getBookedSlotsLoading: true,
  getBookedSlotsSuccess: null,
  getBookedSlotsFailure: null
})
const getBookedSlotsSuccess = (state, { res }) => ({
  ...state,
  getBookedSlotsLoading: false,
  getBookedSlotsSuccess: res,
  getBookedSlotsFailure: null
})
const getBookedSlotsFailure = (state, { error }) => ({
  ...state,
  getBookedSlotsLoading: false,
  getBookedSlotsSuccess: null,
  getBookedSlotsFailure: error
})
//
const createNewAppointmentLoading = state => ({
  ...state,
  createNewAppointmentLoading: true,
  createNewAppointmentSuccess: null,
  createNewAppointmentFailure: null
})
const createNewAppointmentSuccess = (state, { res }) => ({
  ...state,
  createNewAppointmentLoading: false,
  createNewAppointmentSuccess: res,
  createNewAppointmentFailure: null
})
const createNewAppointmentFailure = (state, { error }) => ({
  ...state,
  createNewAppointmentLoading: false,
  createNewAppointmentSuccess: null,
  createNewAppointmentFailure: error
})
//
const validateAppointmentLoading = state => ({
  ...state,
  validateAppointmentLoading: true,
  validateAppointmentSuccess: null,
  validateAppointmentFailure: null
})
const validateAppointmentSuccess = (state, { res }) => ({
  ...state,
  validateAppointmentLoading: false,
  validateAppointmentSuccess: res,
  validateAppointmentFailure: null
})
const validateAppointmentFailure = (state, { error }) => ({
  ...state,
  validateAppointmentLoading: false,
  validateAppointmentSuccess: null,
  validateAppointmentFailure: error
})
//
const getUpcomingAppointmentsLoading = state => ({
  ...state,
  getUpcomingAppointmentsLoading: true,
  getUpcomingAppointmentsSuccess: null,
  getUpcomingAppointmentsFailure: null
})
const getUpcomingAppointmentsSuccess = (state, { res }) => ({
  ...state,
  getUpcomingAppointmentsLoading: false,
  getUpcomingAppointmentsSuccess: res,
  getUpcomingAppointmentsFailure: null
})
const getUpcomingAppointmentsFailure = (state, { error }) => ({
  ...state,
  getUpcomingAppointmentsLoading: false,
  getUpcomingAppointmentsSuccess: null,
  getUpcomingAppointmentsFailure: error
})

const newDonorBonusEligibilityLoading = state => ({
  ...state,
  newDonorBonusEligibilityLoading: true,
  newDonorBonusEligibilitySuccess: null,
  newDonorBonusEligibilityFailure: null
})
const newDonorBonusEligibilitySuccess = (state, { res }) => ({
  ...state,
  newDonorBonusEligibilityLoading: false,
  newDonorBonusEligibilitySuccess: res,
  newDonorBonusEligibilityFailure: null
})
const newDonorBonusEligibilityFailure = (state, { error }) => ({
  ...state,
  newDonorBonusEligibilityLoading: false,
  newDonorBonusEligibilitySuccess: null,
  newDonorBonusEligibilityFailure: error
})
const updateGiftCardPreferenceLoading = state => ({
  ...state,
  updateGiftCardPreferenceLoading: true,
  updateGiftCardPreferenceSuccess: null,
  updateGiftCardPreferenceFailure: null
})

const updateGiftCardPreferenceSuccess = (state, { res }) => ({
  ...state,
  updateGiftCardPreferenceLoading: false,
  updateGiftCardPreferenceSuccess: res,
  updateGiftCardPreferenceFailure: null
})

const updateGiftCardPreferenceFailure = (state, { error }) => ({
  ...state,
  updateGiftCardPreferenceLoading: false,
  updateGiftCardPreferenceSuccess: null,
  updateGiftCardPreferenceFailure: error
})

//
const cleanAppointmentState = state => ({
  ...state,
  appointments: null,
  appointmentsSelected: null,
  scheduleAppointmentSuccess: null,
  scheduleQuickAppointmentSuccess: null,
  getAppointmentSuccess: null,
  rescheduleAppointmentSuccess: null,
  cancelAppointmentSuccess: null,
  getAvailableSlotsSuccess: null,
  getUpcomingAppointmentsSuccess: null,
  getBookedSlotsSuccess: null
})

export const reducer = createReducer(INITIAL_STATE, {
  [AppointmentsTypes.SCHEDULE_APPOINTMENT_LOADING]: scheduleAppointmentLoading,
  [AppointmentsTypes.SCHEDULE_APPOINTMENT_SUCCESS]: scheduleAppointmentSuccess,
  [AppointmentsTypes.SCHEDULE_APPOINTMENT_FAILURE]: scheduleAppointmentFailure,

  [AppointmentsTypes.SCHEDULE_QUICK_APPOINTMENT_LOADING]: scheduleQuickAppointmentLoading,
  [AppointmentsTypes.SCHEDULE_QUICK_APPOINTMENT_SUCCESS]: scheduleQuickAppointmentSuccess,
  [AppointmentsTypes.SCHEDULE_QUICK_APPOINTMENT_FAILURE]: scheduleQuickAppointmentFailure,

  [AppointmentsTypes.GET_ALL_APPOINTMENTS_LOADING]: getAllAppointmentsLoading,
  [AppointmentsTypes.GET_ALL_APPOINTMENTS_SUCCESS]: getAllAppointmentsSuccess,
  [AppointmentsTypes.GET_ALL_APPOINTMENTS_FAILURE]: getAllAppointmentsFailure,

  [AppointmentsTypes.GET_APPOINTMENT_LOADING]: getAppointmentLoading,
  [AppointmentsTypes.GET_APPOINTMENT_SUCCESS]: getAppointmentSuccess,
  [AppointmentsTypes.GET_APPOINTMENT_FAILURE]: getAppointmentFailure,

  [AppointmentsTypes.RESCHEDULE_APPOINTMENT_LOADING]: rescheduleAppointmentLoading,
  [AppointmentsTypes.RESCHEDULE_APPOINTMENT_SUCCESS]: rescheduleAppointmentSuccess,
  [AppointmentsTypes.RESCHEDULE_APPOINTMENT_FAILURE]: rescheduleAppointmentFailure,

  [AppointmentsTypes.CANCEL_APPOINTMENT_LOADING]: cancelAppointmentLoading,
  [AppointmentsTypes.CANCEL_APPOINTMENT_SUCCESS]: cancelAppointmentSuccess,
  [AppointmentsTypes.CANCEL_APPOINTMENT_FAILURE]: cancelAppointmentFailure,

  /* NEW */

  [AppointmentsTypes.GET_AVAILABLE_SLOTS_LOADING]: getAvailableSlotsLoading,
  [AppointmentsTypes.GET_AVAILABLE_SLOTS_SUCCESS]: getAvailableSlotsSuccess,
  [AppointmentsTypes.GET_AVAILABLE_SLOTS_FAILURE]: getAvailableSlotsFailure,

  [AppointmentsTypes.GET_BOOKED_SLOTS_LOADING]: getBookedSlotsLoading,
  [AppointmentsTypes.GET_BOOKED_SLOTS_SUCCESS]: getBookedSlotsSuccess,
  [AppointmentsTypes.GET_BOOKED_SLOTS_FAILURE]: getBookedSlotsFailure,

  [AppointmentsTypes.CREATE_NEW_APPOINTMENT_LOADING]: createNewAppointmentLoading,
  [AppointmentsTypes.CREATE_NEW_APPOINTMENT_SUCCESS]: createNewAppointmentSuccess,
  [AppointmentsTypes.CREATE_NEW_APPOINTMENT_FAILURE]: createNewAppointmentFailure,

  [AppointmentsTypes.VALIDATE_APPOINTMENT_LOADING]: validateAppointmentLoading,
  [AppointmentsTypes.VALIDATE_APPOINTMENT_SUCCESS]: validateAppointmentSuccess,
  [AppointmentsTypes.VALIDATE_APPOINTMENT_FAILURE]: validateAppointmentFailure,

  [AppointmentsTypes.GET_UPCOMING_APPOINTMENTS_LOADING]: getUpcomingAppointmentsLoading,
  [AppointmentsTypes.GET_UPCOMING_APPOINTMENTS_SUCCESS]: getUpcomingAppointmentsSuccess,
  [AppointmentsTypes.GET_UPCOMING_APPOINTMENTS_FAILURE]: getUpcomingAppointmentsFailure,

  [AppointmentsTypes.NEW_DONOR_BONUS_ELIGIBILITY_LOADING]: newDonorBonusEligibilityLoading,
  [AppointmentsTypes.NEW_DONOR_BONUS_ELIGIBILITY_SUCCESS]: newDonorBonusEligibilitySuccess,
  [AppointmentsTypes.NEW_DONOR_BONUS_ELIGIBILITY_FAILURE]: newDonorBonusEligibilityFailure,
  
  [AppointmentsTypes.UPDATE_GIFT_CARD_PREFERENCE_LOADING]: updateGiftCardPreferenceLoading,
  [AppointmentsTypes.UPDATE_GIFT_CARD_PREFERENCE_SUCCESS]: updateGiftCardPreferenceSuccess,
  [AppointmentsTypes.UPDATE_GIFT_CARD_PREFERENCE_FAILURE]: updateGiftCardPreferenceFailure,

  [AppointmentsTypes.CLEAN_APPOINTMENT_STATE]: cleanAppointmentState
})
